import { render } from "./DeveLoper.vue?vue&type=template&id=b4af295c"
import script from "./DeveLoper.vue?vue&type=script&lang=js"
export * from "./DeveLoper.vue?vue&type=script&lang=js"

import "./DeveLoper.vue?vue&type=style&index=0&id=b4af295c&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__